/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Rounds_Round_NInputs */



/**
* | output |
* | --- |
* | "Round {n}" |
*
* @param {Rounds_Round_NInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_round_n = /** @type {((inputs: Rounds_Round_NInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Round_NInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n}`)
	return /** @type {LocalizedString} */ (`Round ${i?.n}`)
});